import { hasSkin } from '../../utils';
import { VideoStyleStrategy } from './video-style-strategy';

export class InArticleRevealVideoStyleStrategy extends VideoStyleStrategy {
  REVEAL_COVER_RATIO_THRESHOLD_MAX = 0.6;
  REVEAL_COVER_RATIO_THRESHOLD_MIN = 0.5;

  protected getVideoStyle(): Record<string, string | number> {
    let videoStyle = super.getVideoStyle();

    if (hasSkin(this.configStore.config) || this.videoStore.isVpaid) {
      return videoStyle;
    }

    const frameRatio = window.innerWidth / window.innerHeight;

    if (
      frameRatio >= this.REVEAL_COVER_RATIO_THRESHOLD_MIN &&
      frameRatio <= this.REVEAL_COVER_RATIO_THRESHOLD_MAX
    ) {
      videoStyle['object-fit'] = 'cover';
    }

    return videoStyle;
  }
}
